<section>
  <div class="bg3" style="height: 450px">
    <div class="" style="padding:50px">
      <h1>How to Guides</h1>
      <p class="header-text">Golf GamesKeeper provides detailed how-to guides to help you with the different functionalities available to you. Please
        select from the different guides, if you do not find what you are looking for please contact us.</p>
    </div>
  </div>
</section>
<section>
  <mat-tab-group color="accent" (selectedTabChange)='selectionChange($event)' ngClass.gt-xs='desktop' ngClass.lt-sm='mobile'>
    <mat-tab label="Create a Group">

      <h3>How to create a Group or League</h3>
      <p>Every well organized event starts with a well defined group. </p>
      <p>When creating a group it's important to understand the effect of each option, so let's start with that. </p>

      <h4>Group Name: </h4>
      <p>Your Group name </p>

      <h4>Track Handicap: </h4>
      <p>When this option is selected, Golf GamesKeeper will calculate a handicap with only the rounds played within the group. Also
        note that any players added to this group will be added with a handicap of 0. </p>

      <h4>Handicap Day (optional): </h4>
      <p>This option appears only when Track Handicap is selected and allows the group administrator to select a day of the
        week where the group handicaps are calculated.
      </p>
      <h4>Allow Self-Registration: </h4>
      <p>When this option is selected, Golf GamesKeeper will send an email notification to all members of the group (unless the event
        is private or the players opt-in options are not set to receive event notifications) when a new event is created.
        Every player is then allowed to register themselves to an event. Even if a player opts-out of event notification
        by email, the notification will be saved in his/her notification center accessible through the Dashboard.
      </p>
      <h4>Registration Deadline (optional): </h4>
      <p>When Self-Registration is enabled, this option allows the group administrator to set hard deadlines for event registrations.
        This option accepts decimal, 1.5 days is 36 hours, so a deadline of 8pm on Thursday for an event at 8am on Saturday.
      </p>
      <h4>Net Skins: </h4>
      <p>% of the Course Handicap to be applied for net skins.
      </p>
      <h4>Scorecard playoffs: </h4>
      <p>These options allows you to select the handicap hole order for the scorecard playoffs. We do not offer USGA scorecard
        playoffs at this time.
      </p>

      <h4>Now that you are familiar with the options of group creation, lets look at a few popular group options. </h4>
      <div *ngIf="selectedTabIndex == 0">
        <mat-accordion [multi]='false'>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'" ngClass.gt-xs='expansion-header-desktop'
              ngClass.lt-sm='expansion-header-mobile'>
              <mat-panel-title>
                Q - I want to create a group that tracks handicap, however, I need to start with a handicap for each guy.
              </mat-panel-title>
            </mat-expansion-panel-header>
            A - The best way to do this is to originally create a group that does not track handicap, this way as you add players to
            your group, Golf GamesKeeper will use their personal index as the group handicap. Once you have played a few rounds
            within the group, you can turn on track handicap and Golf GamesKeeper will now update the handicap for all your players.
            Please note that in a Group Handicap Calculation, Golf GamesKeeper will not replace your handicap with a non calculated
            0.0.

          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'" ngClass.gt-xs='expansion-header-desktop'
              ngClass.lt-sm='expansion-header-mobile'>
              <mat-panel-title>
                Q - I have a large group of people and I want to invite only a few to play for specific events. How do I do that?
              </mat-panel-title>
            </mat-expansion-panel-header>
            A - This is done through private events. At event creation check the Private check box and on step 3 (Players), invite only
            the players that you want to get notification of the event. No other notifications will go out.
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'" ngClass.gt-xs='expansion-header-desktop'
              ngClass.lt-sm='expansion-header-mobile'>
              <mat-panel-title>
                Q - I created an event and none of my players received the invitation email to participate.
              </mat-panel-title>
            </mat-expansion-panel-header>
            A - Please make sure that your Group allows for self-registration, if it does, your player may have opted-out of event notification.
            To opt-in for Event Notifications, login to GolfGamesKeeper.com, go to your Profile, Opt-in Options tab, check Event
            Notifications and click the Save Options button.
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-tab>
    <mat-tab label="Create an Event">

      <h3>How to Create an Event</h3>
      <p>When creating an event think about how you want to handle the different settings in the first step.</p>

      <h4>Event Name:</h4>
      <p>Your Event name </p>

      <h4>Number of Foursomes: </h4>
      <p>If you use this option, Golf GamesKeeper will limit the amount of players that can participate in the event. "0" is used for
        no limit and is the default. </p>

      <h4>Private: </h4>
      <p>In a private event, the administrator of the group decides which players are invited to the event by selecting them
        in the Players tab. By default this is unchecked.
      </p>
      <h4>Date:</h4>
      <p>Select the date of your event from the popup calendar or by just entering the date.
      </p>
      <h4>Multi Round Event:</h4>
      <p>This option will change the event creation screen and the number of steps to create your event, this is used for both
        multi day and multi round events.
      </p>
      <h4>Event Time:</h4>
      <p>Select the first starting time of your event from the hour and minute select menus.
      </p>
      <h4>Event Type:</h4>
      <p>Select your event type of either Shotgun or Tee Times.
      </p>

      <h4>Scoring:</h4>
      <p>
        Select your scoring format, you have multiple options to choose from (Stroke Play, Stableford, Chicago, Shamble (net, gross,
        or net & gross), and Team net/gross).
      </p>

      <h4>State/Course/Tees:</h4>
      <p> Select the state, course and tees you are playing. We currently have over 15,000 courses in our database in the United
        States.
      </p>

      <p>After you have completed the first step of event creation the remainder of the process is pretty straightforward.</p>

      <h4>Different things to think about when you are creating your events. </h4>
      <div *ngIf='selectedTabIndex == 1'>

        <mat-accordion [multi]='false'>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'" ngClass.gt-xs='expansion-header-desktop'
              ngClass.lt-sm='expansion-header-mobile'>
              <mat-panel-title>
                Q - How can I limit the number of players in my event?
              </mat-panel-title>
            </mat-expansion-panel-header>
            A - You can do this in 3 ways:
            <ol>
              <li>
                Use the Number of Foursome(s) option. If you use this option, Golf GamesKeeper will limit the amount of players that can participate
                in the event.
              </li>
              <li>
                Set your event to Private (default value). In a private event, the administrator of the group decides which players are invited
                to the event by selecting them in the Players tab. Please note that only the players selected will have an
                option to Accept/Reject your invitation.
              </li>
              <li>
                A combination of both, set a Number of Foursomes and make the event private, this will give you more flexibility to add players
                when needed.
              </li>
            </ol>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'" ngClass.gt-xs='expansion-header-desktop'
              ngClass.lt-sm='expansion-header-mobile'>
              <mat-panel-title>
                Q - Can I have individual stroke play and a two- or four-man best ball scoring option at the same time?
              </mat-panel-title>
            </mat-expansion-panel-header>
            A - Yes, you would select "Stroke Play" on the first tab of event creation. Then, on the "Scoring Option" tab you can add
            any other team option to the same event.
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'" ngClass.gt-xs='expansion-header-desktop'
              ngClass.lt-sm='expansion-header-mobile'>
              <mat-panel-title>
                Q - Can I have players in my event play from different tees?
              </mat-panel-title>
            </mat-expansion-panel-header>
            A - Yes, you can select the different tees for each player on the "Player Options" tab, this will also adjust their course
            handicap.
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-tab>
    <mat-tab label='Manage Players'>

      <h3>How to manage players</h3>
      After you have created your group you can now add players. From your dashboard identify the group you want to modify and
      click on the "Add/Remove players" link .
      <br />
      <br /> You have four options for adding players:
      <br />
      <br />
      <b>Single Player:</b>
      <br /> Information needed is first name, last name, email, handicap. This will add one player to your list of available players.
      <br />
      <br />
      <b>From Other Groups:</b>
      <br /> If you already are a member of another group, this option allows you to add players from other groups or leagues (that
      you are either an admin or member of) within your dashboard.
      <br />
      <br />
      <b>From File:</b>
      <br /> This last option allows you to upload a "CSV - Comma-Separated" file with the same information that you use in the
      other options: first name, last name, email, handicap.
      <br /> After you have added your players using the options above you will see what you can now do with your player list.
      You can search through your players, email your players, view the rounds of your players or remove players from your
      group.
      <br />
      <br />
      <b>Adding a player without email:</b>
      <p>
        If you need to add a player to your event and you do not have his/her email address, you can add the player with a bogus
        address and change the player email at a later time by clicking the
        <i class='fa fa-info-circle'></i> button in the Players section of your group or league.
      </p>
      <b>Inviting a player to your event:</b>
      <p>
        You can invite a player to your event by forward the Event Registration email to them, the guest will automatically be added
        to your group and will receive event notifications.

      </p>
      <div *ngIf="selectedTabIndex == 2">

      </div>
    </mat-tab>
    <mat-tab label='Calculating Course Handicaps'>
      <h3>How we calculate the Course Handicap for the different games we offer.</h3>
      <b>Stroke Play, Match Play</b>
      <p>For these we use the standard USGA formula which is [index * slope / 113].</p>
      <b>Best Ball, Shamble</b>
      <p>In these types of games, each player gets their stroke play handicap</p>
      <b>Chicago/Quota/Stableford</b>
      <p>For these format the Course Handicap is calculated the same as stroke or match play, however the scoring system is
        different. Rather than counting the total number of strokes taken, as in stroke play, it involves scoring points
        based on the number of strokes taken at each hole. Golf GamesKeeper allows you to change the default scoring value for each
        of these games.</p>
      <b>Alternate Shot Match Play, 2 Person Scramble Match Play, 2 Person Scramble (60/40), 2 Person Chapman</b>
      <p>Calculations for this type of events are based on Individual Course Handicap, each player gets a Course Handicap Calculated,
        we then take the sum of 60% of the low handicap and 40% of the high handicap</p>
      <ul>
        <li>
          Team player A has an index of 8.3 and Team Player B has an index of 14.5, they play on a course with a slope of 131.</li>
        <li>
          Player Course Handicaps are 10 (8.3*131/113) and 17 (14.5*131/113)
        </li>
        <li>
          Team Course Handicap is 10*0.6 + 17*0.4 = 12.8 => Rounded to 13
        </li>
      </ul>
      <p>In the event that that any team game is played on 9 holes only, the calculation will be done like so:</p>
      <ul>
        <li>
          Team player A has an index of 8.3 and Team Player B has an index of 14.5, they play on a course with a slope of 131.</li>
        <li> Player Course Handicaps are 10 (8.3*131/113) and 17 (14.5*131/113)
        </li>
        <li>Team Course Handicap is 10*0.6 + 17*0.4 = 12.8 => NOT ROUNDED</li>
        <li>
          Team Course Handicap 12.8 divided by 2 then round to closer integer. 12.8/2 = 6.4 => Rounded to 6
        </li>
      </ul>
      <b>2 Person Scramble (Ambrose)</b>
      <p>For this type of event we use 25% of the sum of the calculated Course Handicaps</p>
      <ul>
          <li>
            Team player A has an index of 8.3 and Team Player B has an index of 14.5, they play on a course with a slope of 131.</li>
          <li> Player Course Handicaps are 10 (8.3*131/113) and 17 (14.5*131/113)
          </li>
          <li>27 *.25 =  6.75 => Rounded to 7</li>
        </ul>
        <b>2 Person Scramble (40%)</b>
        <p>For this type of event we use 40% of the sum of the calculated Course Handicaps</p>
        <ul>
            <li>
              Team player A has an index of 8.3 and Team Player B has an index of 14.5, they play on a course with a slope of 131.</li>
            <li> Player Course Handicaps are 10 (8.3*131/113) and 17 (14.5*131/113)
            </li>
            <li>27 *.40 =  10.8 => Rounded to 11</li>
          </ul>
    
    </mat-tab>
    <mat-tab label='Golf Game Formats'>
      <h3>Here are a few of the well known Golf Game Formats</h3>
      <h4>Stroke Play</h4>
      <p>Stroke play is the most common form of golf played by golfers and well-known even by non-golfers. 
        In stroke play, a golfer counts the strokes used to complete the play of each hole, then adds up the total number of those strokes at the end of the round for his score. 
        Compare your score to the score of all other golfers you're competing against to determine your standing. Simple!</p>
      <p>Stroke play is also called medal play.</p>
      <h4>Match Play</h4>
      <p>Match play is one of the main forms of competition in golf. 
        It pits players one against another, rather than one against the field as in stroke play. 
        Opponents compete to win individual holes, and the player who wins the most holes wins the match.</p>
      <p>Match play can be played by two individuals, one on one, and that is known as Singles Match Play. 
        Or teams of two players can square off, with Foursomes and Fourball the most common formats for team play.</p>
      <p>To learn more about match play, explore the topics below</p>
    </mat-tab>
    <mat-tab label='Videos'>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div class="video-image-div">
          <div>
            <h4>League Control Panel</h4>
            <h6>League Settings</h6>
          </div>
          <img class="video-image" src="/assets/images/video-1-thumbnail.bmp" (click)="playVideo('video-1.mp4')"/><br/>
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
            <i class="fa fa-3x fa-play" (click)="playVideo('video-1.mp4')"></i>
            <a href="https://www.youtube.com/watch?v=bsibUq7lcQY" target="new"><i class="fa fa-3x fa-youtube"></i></a>
          </div>
      </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</section>